import { NoneLabel } from '@/components/labels/NoneLabel';
import { HorizontalStack } from '@/components/utils/linearLayouts';
import { Box, Typography } from '@mui/material';
import React, { ComponentProps, FC, ReactNode } from 'react';

type LabelTypographyProps = {
    children: ReactNode;
};

export const LabelTypography: FC<LabelTypographyProps> = ({ children }) => (
    <Typography
        variant='body2'
        fontSize={'14px'}
        lineHeight={'20px'}
        color={'#757575'}
        sx={{ minWidth: '150px' }}
    >
        {children}
    </Typography>
);

type ValueTypographyProps = ComponentProps<typeof Typography> & {
    children: ReactNode;
};

export const ValueTypography: FC<ValueTypographyProps> = ({ children, ...props }) => (
    <Typography variant='body2' fontSize={'14px'} lineHeight={'20px'} {...props}>
        {children}
    </Typography>
);

type SectionLayoutProps = {
    title: string;
    editButtons?: ReactNode;
    children: ReactNode;
    headingComponent?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

export const SectionLayout: FC<SectionLayoutProps> = (props) => {
    const { title, editButtons, children, headingComponent = 'h2' } = props;

    return (
        <div style={{ padding: '32px', border: '1px solid #E0E0E0' }}>
            <Typography
                component={headingComponent}
                variant={headingComponent}
                lineHeight={'24px'}
                fontWeight={500}
                mb={1}
            >
                {title}
            </Typography>
            {editButtons && <Box sx={{ justifySelf: 'end' }}>{editButtons}</Box>}
            {children}
        </div>
    );
};

type FieldDisplayProps = {
    label: string;
    value: ReactNode;
    noneLabelText?: string;
};

export const FieldDisplay: FC<FieldDisplayProps> = (props) => {
    const { label, value, noneLabelText } = props;

    return (
        <HorizontalStack spacing={4} alignItems='flex-start' fullWidth>
            <LabelTypography>{label}</LabelTypography>
            {value ? (
                <ValueTypography flex={1}>{value}</ValueTypography>
            ) : (
                <NoneLabel fontSize={'14px'} lineHeight={'20px'} text={noneLabelText} />
            )}
        </HorizontalStack>
    );
};
